var map = {
	"./4902720092081_1.jpg": "2b92",
	"./4902720092081_2.jpg": "1d77",
	"./4902720092085_1.png": "cf44",
	"./4902720092085_2.png": "3923",
	"./Cigar.jpg": "9801",
	"./Cigar2.jpg": "343c",
	"./chivas-21-nam-royal-salute-190.jpg": "1c42",
	"./chivas-21-nam-royal-salute-_2.jpg": "5fc2",
	"./ruou-chivas-12-750-ml-2.jpg": "af14",
	"./ruou-chivas-12-750-ml.jpg": "0418",
	"./ruou_vang_1.jpg": "c4df",
	"./ruou_vang_2.jpg": "22a9",
	"./sua-morinaga-2-chilmil-3.jpg": "1c07",
	"./taoambro.jpg": "b5eb",
	"./taoambro2.jpeg": "d275",
	"./taoambro3.jpeg": "399a",
	"./thanhlong1.jpg": "3138",
	"./thanhlong2.jpeg": "6d05",
	"./thanhlong3.jpg": "c1e0",
	"./vien-uong-hapanix-1.jpg": "41f5",
	"./vien-uong-hapanix-2.jpg": "a2eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7536";